import { card, typo, Button, boxShadowZ1, ActionButton } from '@cycle-app/ui';
import { ColorTheme } from '@cycle-app/utilities';
import styled, { css } from 'styled-components';

import { PortalModal } from 'src/components/PortalModal';

export const PublicChangeLogContainer = styled.div`
  ${card}
  width: 780px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const Title = styled.h5`
  ${typo.headerSmall}
  color: ${p => p.theme.colors.text.primary};
`;

export const Bold = styled.span`
  ${typo.body500}
  color: ${p => p.theme.colors.text.primary};
`;

export const Description = styled.span`
  ${typo.body400}
  color: ${p => p.theme.colors.text.secondary};
`;

export const ReleasesListContainer = styled.div`
  ${card}
  width: 780px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

type ReleaseItemsProps = {
  $hasMinDimensions: boolean;
};

export const ReleaseItems = styled.ul<ReleaseItemsProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;

  ${p => p.$hasMinDimensions && css`
    width: 100%;
    height: 345px;
  `}
`;

export const ReleaseItem = styled.li`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0;
`;

export const Badge = styled.span`
  ${typo.caption400}
  display: inline-flex;
  padding: 0px 4px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background-color: ${p => (p.theme.isDark ? ColorTheme.Grey850 : ColorTheme.Grey100)};
  color: ${p => p.theme.colors.text.disabled};
`;

export const RequestButton = styled(Button).attrs({
  size: 'M',
  variant: 'outlined-alt',
})`
  ${boxShadowZ1}
`;

export const Modal = styled(PortalModal)`
  width: 690px;
  padding: 64px 86px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const ModalTitle = styled.h4`
  ${typo.headerLarge600}
  color: ${p => p.theme.colors.text.primary};
  margin-bottom: 40px;
  text-align: center;
`;

export const ModalItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  background-color: ${p => (p.theme.isDark ? ColorTheme.Grey800 : ColorTheme.Grey100)};

  > div:first-child {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    background-color: ${p => (p.theme.isDark ? ColorTheme.Grey850 : ColorTheme.White)};
    border-radius: 8px;
    color: ${p => p.theme.colors.text.primary};
  }

  > div:last-child {

    h5 {
      ${typo.body500}
      color: ${p => p.theme.colors.text.primary};
    }

    p {
      ${typo.body400}
      color: ${p => p.theme.colors.text.secondary};
    }
  }
`;

export const CloseButton = styled(ActionButton)`
  position: absolute;
  top: 16px;
  right: 16px;
`;
